// extracted by mini-css-extract-plugin
module.exports = {"button":"TimeActionButton_button__3a4GK","button--background":"TimeActionButton_button--background__3HJ3K","button--text":"TimeActionButton_button--text__1dL12"};